export const DEV_TOKEN_ID = process.env.REACT_APP_TOKENID;
export const GTM_ID = process.env.REACT_APP_GTMID; //google tag manager

export const TEXT_INPUT_TYPE = {
  text: "text",
  password: "password",
  number: "number",
  telephone: "tel",
  email: "email",
};

export const DEFAULT = "default";

export const AXIS = {
  vertical: "vertical",
  horizontal: "horizontal",
};

export const GLOBAL_LOADER_VARIANT = {
  indeterminate: "indeterminate",
  determinate: "determinate",
};

export const COLOR = {
  primary: "primary",
  secondary: "secondary",
  danger: "danger",
  invert: "invert",
  light: "light",
  lightGray: "lightGray",
  badge: "badge",
  dark: "dark",
  tertiary: "tertiary",
  white: "white",
  link: "link",
  success: "success",
  warning: "warning",
  blue: "blue",
  orange: "orange",
};

export const ICON_BUTTON_COLOR = {
  lightGray: "lightGray",
  midGray: "midGray",
  darkGray: "darkGray",
  shadowGray: "shadowGray",
  blue: "blue",
  green: "green",
};

export const VARIENT = {
  contained: "contained",
  outlined: "outlined",
  empty: "empty",
  text: "text",
};

export const SIZE = {
  _3xs: "3xs",
  xxs: "xxs",
  xs: "xs",
  small: "s",
  smallh: "sh",
  medium: "m",
  large: "l",
  xl: "xl",
  xlh: "xlh",
  xxl: "xxl",
  _3xl: "3xl",
  _4xl: "4xl",
  _4xlh: "4xlh",
  _5xl: "5xl",
  _6xl: "6xl",
  _7xl: "7xl",
  _8xl: "8xl",
  _9xl: "9xl",
  _10xl: "10xl",
  max: "max",
};

export const SHADOW = {
  none: "none",
  shadow1: "shadow1",
  shadow2: "shadow2",
  shadow3: "shadow3",
  shadow4: "shadow4",
};

export const SHAPE_TYPE = {
  circle: "circle",
  square: "square",
};

export const BORDER_TYPE = {
  basic: "basic",
  rounded: "rounded",
};

export const TEXT = {
  capitalize: "capitalize",
  uppercase: "uppercase",
  lowercase: "lowercase",
};

export const TEXT_DECORATION = {
  bold: "bold",
  underline: "underline",
};

export const RADIUS_SIZE = {
  none: "none",
  small: "s",
  medium: "m",
  xl: "xl",
};

export const DIRECTION = {
  ltr: "ltr",
  rtl: "rtl",
};

export const POSITION = {
  start: "start",
  center: "center",
  end: "end",
};

export const SIDE = {
  left: "left",
  right: "right",
  start: "flex-start",
  center: "center",
  end: "flex-end",
};

export const HTTP_ERROR_CODES = {
  badRequest: 400,
  unauthorized: 401,
  paymentRequired: 402,
  forbidden: 403,
  notFound: 404,
};

/*eslint no-useless-escape:0*/
export const EMAIL_ADDRESS_REGEX = /^\S+@\S+\.\S+$/;

export const PRIVACY_POLICY_LINK = "https://www.fireberry.com/privacypolicy";
export const TERMS_LINK = "https://www.fireberry.com/termsofservice";

export const LANGUAGE_FORMAT = {
  he: "he-il",
  us: "en-us",
};

export const LANGUAGE_CODE = {
  he: "he",
  us: "en",
};

export const ICON_ANIMATION_TYPE = {
  spin: "spin",
};

export const INDUSTRY_TYPES = {
  sales: "sales",
  realEstate: "realEstate",
  customerSuccess: "customerSuccess",
  customerService: "customerService",
  education: "education",
  agency: "agency",
  insurance: "insurance",
  hr: "hr",
  projectManagement: "projectManagement",
  healthCare: "healthCare",
  nonProfit: "nonprofit",
  other: "other",
};

export const ERROR_MSG = {
  required: "זהו שדה חובה",
  emailMsg: "כתובת המייל אינה תקינה",
  phoneMsg: "מספר הטלפון אינו תקין",
  recaptchMsg: "*יש לסמן שאינך רובוט",
  serverErrMsg: "שגיאה! נא מלאו את הפרטים בשנית",
};

export const SUBJECT_OPTIONS = [
  { label: "שאלה לגבי המוצר", value: 1 },
  { label: "שאלה למכירות/מחיר", value: 2 },
  { label: "תמיכה טכנית", value: 3 },
  { label: "ממשקים/API", value: 4 },
  { label: "שותפים עסקיים", value: 5 },
  { label: "כנס לקוחות", value: 6 },
  { label: "אבטחת מידע והגנת פרטיות", value: 7 },
  { label: "רכישת חבילת SMS", value: 12 },
  { label: "רכישת שירותים", value: 13 },
];

export const SUCCESS_MSG = {
  primaryHeader: "הפרטים נשלחו בהצלחה!",
  secondaryHeader: "נציגי החברה יצרו איתך קשר בהקדם.",
};

export const SERVICE_DESCRIPTION = [
  "אני מעוניין לרכוש התממשקות למרכזיית ענן",
  "אני מעוניין לרכוש חבילת תמיכה מתקדמת",
  "אני מעוניין לרכוש חבילת הדרכה",
  "אני מעוניין לרכוש שירותים מותאמים אישית",
];

export const FULL_LENGTH = "100%";

export const UTM_PARAMETERS = [{ parameterName: "gclid", fieldName: "gclid" }];

export const UTM_COOKIES_PARAMETERS = [
  { cookieName: "_app_track_visitor_id", fieldName: "pcfvisitorid" },
  { cookieName: "_app_track_1_ip", fieldName: "pcfgeoipaddress" },
  { cookieName: "_app_track_1_geocity", fieldName: "pcfgeocity" },
  { cookieName: "_app_track_1_georegion", fieldName: "pcfgeoregion" },
  { cookieName: "_app_track_1_geoorg", fieldName: "pcfutmnetwork" },
  { cookieName: "_app_track_1_geotimezone", fieldName: "pcftimezone" },
  { cookieName: "_app_track_1_geocountry", fieldName: "pcfgeocountry" },
  { cookieName: "_app_track_1_pid", fieldName: "pid" },
  { cookieName: "_app_track_1_utm_source", fieldName: "pcfutmsource" },
  { cookieName: "_app_track_1_utm_medium", fieldName: "pcfutmmedium" },
  { cookieName: "_app_track_1_utm_campaign", fieldName: "pcfutmcampaign" },
  { cookieName: "_app_track_1_utm_term", fieldName: "pcfutmterm" },
  { cookieName: "_app_track_1_utm_content", fieldName: "pcfutmcontent" },
  { cookieName: "_app_track_1_gclid", fieldName: "gclid" },
];
